<template>
  <div class="activity-table-wrapper">
    <vue-good-table
      :class="{loading: loading}"
      ref="table"
      :rows="audit"
      :columns="tableColumns"
      @on-row-click="onRowClick"
      styleClass="vgt-table"
      :expandedOptions="{key: '_id', expandedRows, styleClass: 'expanded'}"
    >
      <template slot="expanded-row" slot-scope="props">
        <audit-info
          :audit="props.row"
          :morph="infoMorph"
          :display-account="displayAccount()"
        />
      </template>
      <template slot="table-row" slot-scope="props">
        <span v-if="props.column.field == 'date'">
          <span v-date="{ date: props.row.created_at, format: $settings.dateTimeFormatSec }" />
        </span>
        <span v-if="props.column.field == 'what'">
          <span :class="`action-wrapper custom-border ${getCategoryClasses(props.row)}`">
            {{ props.row.action.action.toUpperCase() }}
          </span>
        </span>
        <span v-if="props.column.field == 'who'">
          <audit-link
            :audit="props.row"
            morph="who"
          />
        </span>
        <span v-if="props.column.field == 'source'">
          <audit-link
            :audit="props.row"
            morph="on_what"
          />
        </span>
        <span v-if="props.column.field == 'account'">
          <audit-link
            :audit="props.row"
            morph="account"
          />
        </span>
        <span v-if="props.column.field == 'toggle'">
          <icon
            :icon="expandedRows.includes(props.row._id) ? 'chevron-up' : 'chevron-down'"
          />
        </span>
      </template>
    </vue-good-table>
    <div
      class="loading-wrapper overlay"
      :class="{'d-none': !loading}"
    >
      <loading-icon
        :loading="loading"
        loading-class="text-center vertical-middle"
      />
    </div>
  </div>
</template>
<script>
import {VueGoodTable} from 'vue-good-table'
import AuditLink from '@/components/AuditLink'
import AuditInfo from '@/components/AuditInfo'
import Date from '@/directives/date'

const baseTableColumns = [
  {
    label: 'Date',
    field: 'date',
  },
  {
    label: 'What',
    field: 'what',
  },
]

export default {
  components: {
    AuditLink,
    AuditInfo,
    VueGoodTable,
  },
  directives: {
    Date,
  },
  props: {
    audit: {
      type: Array,
      required: true,
    },
    type: {
      type: String,
      required: true,
    },
    loading: {
      type: Boolean,
      default: true,
    },
  },
  data () {
    const tableColumns = [...baseTableColumns]

    if (this.displayWho()) {
      tableColumns.push({
        label: 'Who',
        field: 'who'
      })
    }

    if (this.displaySource()) {
      tableColumns.push({
        label: 'Source',
        field: 'source'
      })
    }

    if (this.displayAccount()) {
      tableColumns.push({
        label: 'Account',
        field: 'account'
      })
    }

    return {
      // Unused, just as color index
      categories: {
        email: {color: '#93bcff', backgroundColor: 'rgba(147,188,255,0.03)'},
        web: {color: '#00BE9E', backgroundColor: 'rgba(0,190,158,0.03)'},
        admin: {color: '#ff9b9f', backgroundColor: 'rgba(255,155,159,0.03)'},
      },
      auditActions: {
        // Sent notification
        'Sent notification': {
          category: 'email',
          audit: true,
        },

        // article published
        'Article published': {
          category: 'admin',
          audit: false,
        },

        // Viewed article
        'Viewed article': {
          category: 'web',
          audit: false,
        },

        // Downloaded article
        'Downloaded article': {
          category: 'web',
          audit: false,
        },

        // Updated user
        'Updated user': {
          category: 'admin',
          audit: false,
        },

        // Attempted to view article
        'Attempted to view article': {
          category: 'web',
          audit: false,
        },

        // Added to subscription
        'Added to subscription': {
          category: 'admin',
          audit: false,
        },

        // Updated alert lists
        'Updated alert lists': {
          category: 'admin',
          audit: false,
        },

        // Added to account
        'Added to account': {
          category: 'admin',
          audit: false,
        },

        // Removed from subscription
        'Removed from subscription': {
          category: 'admin',
          audit: false,
        },

        // Created an account
        'Created an account': {
          category: 'admin',
          audit: false,
        },

        // Updated account
        'Updated account': {
          category: 'admin',
          audit: false,
        },

        // Removed from account
        'Removed from account': {
          category: 'admin',
          audit: false,
        },

        // Updated subscription
        'Updated subscription': {
          category: 'admin',
          audit: false,
        },

        // Deleted subscription
        'Deleted subscription': {
          category: 'admin',
          audit: false,
        },

        // Created user
        'Created user': {
          category: 'admin',
          audit: false,
        },

        // Logged in
        'Logged in': {
          category: 'web',
          audit: false,
        },

        // Email open
        'Email open': {
          category: 'email',
          audit: false,
        },

        // Email processed
        'Email processed': {
          category: 'email',
          audit: true,
        },

        // Email delivered
        'Email delivered': {
          category: 'email',
          audit: true,
        },

        // Email click
        'Email click': {
          category: 'email',
          audit: false,
        },

        // Email deferred
        'Email deferred': {
          category: 'email',
          audit: true,
        },

        // Email bounce
        'Email bounce': {
          category: 'email',
          audit: true,
        },

        // Email dropped
        'Email dropped': {
          category: 'email',
          audit: true,
        },
      },
      tableColumns: [
        ...tableColumns,
        {
          label: '',
          field: 'toggle',
        },
      ],
      expandedRows: [],
    }
  },
  computed: {
    infoMorph () {
      return this.displaySource() ? 'on_what' : 'who'
    },
  },
  methods: {
    displaySource () {
      return ['account', 'user'].includes(this.type)
    },
    displayWho () {
      return ['article', 'newsletter', 'account'].includes(this.type)
    },
    displayAccount () {
      return this.displayWho() && !this.displaySource()
    },
    onRowClick ({row}) {
      const rowId = row._id
      console.log(rowId)
      if (this.expandedRows.some(id => id == rowId)) {
        this.expandedRows = this.expandedRows.filter(v => v !== rowId)
      } else {
        this.expandedRows.push(rowId)
      }
    },
    getTableClasses (params) {
      return `${this.getAuditClasses(params)} ${this.getCategoryClasses(params.row)}`
    },
    getCategoryClasses (row) {
      const action = row.action.action
      return action in this.auditActions ? `category_${this.auditActions[action].category} custom-border__${this.auditActions[action].category}` : ' category_none custom-border__grey'
    },
    getAuditClasses ({row}) {
      const actionId = row.action_id

      return actionId in this.auditActions && this.auditActions[actionId].audit ? 'is-audit' : ''
    },
  },
}
</script>
